import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { Accordion, Card } from "react-bootstrap";
import {
  renderTableWorklogColumns,
  renderTableWorklogRows,
  getCollapsedStatus,
  toggleAccordion,
  useSortableData,
  HoursWorkedThisWeek,
  WorkingOnWeekend,
  EstimatedHoursNextWeek,
} from "../dashboard-util/dashboard-utils";
import DashboardTableHeader from './DashboardTableHeader';
import TableHeaderColumn from "./TableHeaderColumn";
import WorklogModal from "./WorklogModal";
import MemberIcon from "../../../components/member-icon/member-icon";
import PlanningToWork from "./PlanningToWork";
import WorklogButtonRow from "./WorklogButtonRow";
import "../dashboard-real-estate/dashboard-real-estate.scss";

const formatNumber = (value) => {
  return new Intl.NumberFormat(undefined, {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1
  }).format(value);
}

const DashboardWorklogTracker = ({
  isAllRbc,
  isStaffer,
  currentUserId,
  realEstateTrackerMembers,
  fetchData,
}) => {
  const [members, setMembers] = useState([]);
  const [toggled, setToggled] = useState([]);
  const [show, setShow] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);
  const [accordionId, setAccordionId] = useState(`real-estate-worklogtracker-accordion`);
  const [collapsed, setCollapsed] = useState(true);

  useEffect(() => {
    setMembers(realEstateTrackerMembers);
  }, [realEstateTrackerMembers]);

  const showModal = (m) => {
    setSelectedMember(m);
    setShow(true);
  };

  const onHide = () => setShow(false);

  const { items, requestSort, getArrowDirectionFor } = useSortableData(members);

  if (items !== null && items?.length > 0) {
    return (
      <div className="new-dashboard table-wrapper">
        <div className="DashboardTableWrapper">
          <table>
            <thead>
              <tr className="DashboardTableHeader">
                <DashboardTableHeader
                  trackerType="worklog"
                  accordionId={accordionId}
                  collapsed={collapsed}
                  setCollapsed={setCollapsed}
                  toggled={toggled}
                  setToggled={setToggled}
                  taskId={members[0]?.Id || 0}
                />
              </tr>
            </thead>
            <Accordion>
              <Card className="MemberTableBodyWrapper">
                <thead className="MemberTableColumnHeader">
                  <tr className="MemberTableColumnTitles">
                    <TableHeaderColumn
                      headerText="NAME"
                      sortKey="Name"
                      requestSort={requestSort}
                      getArrowDirectionFor={getArrowDirectionFor}
                      colClass="col-md-3"
                    />
                    <TableHeaderColumn
                      headerText="HOURS WORKED IN CURRENT WEEK"
                      sortKey="HoursThisWeek"
                      requestSort={requestSort}
                      getArrowDirectionFor={getArrowDirectionFor}
                      colClass="col-md-2"
                    />
                    <TableHeaderColumn
                      headerText="PLANNING TO WORK ON THE WEEKEND"
                      sortKey="WorkingWeekend"
                      requestSort={requestSort}
                      getArrowDirectionFor={getArrowDirectionFor}
                      colClass="col-md-2"
                    />
                    <TableHeaderColumn
                      headerText="ESTIMATED HOURS FOR THE NEXT WEEK"
                      sortKey="HoursNextWeek"
                      requestSort={requestSort}
                      getArrowDirectionFor={getArrowDirectionFor}
                      colClass="col-md-2"
                    />
                    <TableHeaderColumn
                      headerText="COMMENTS"
                      sortKey="Comments"
                      requestSort={requestSort}
                      getArrowDirectionFor={getArrowDirectionFor}
                      colClass="col-md-2"
                    />
                  </tr>
                </thead>
              </Card>
              <table className="real-estate-table">
                <tbody className="real-estate-tablebody">
                  {items?.map((member) => {
                    const memberId = member.UserId;
                    const worklogTrackers = member.WorklogTracker;

                    if (!worklogTrackers || worklogTrackers.length === 0) return null;

                    const discardedColumnIds = [];
                    worklogTrackers.forEach(deal => {
                      deal.TableWorklog[0].Columns.forEach(column => {
                        const columnName = column?.Name.trim().toLowerCase();
                        if (HoursWorkedThisWeek.includes(columnName) || WorkingOnWeekend.includes(columnName) || EstimatedHoursNextWeek.includes(columnName)) {
                          discardedColumnIds.push(column.Id);
                        }
                      });
                    });

                    return (
                      <tr key={`${member?.CompanyId}-${member?.UserId}`} className="real-estate-table-row">
                        <Card>
                          <div className="MemberTableBody realEstateRow row">
                            <td className="col-md-3 mt-2 real-estate-username" onClick={() => { showModal(member) }}>
                              <MemberIcon
                                type="user"
                                typeColor={member.TypeColor}
                                className="ml-3"
                                member={{ userNameFull: member.Name }}
                              />
                              <span className="Memberoverlaybutton mt-1 pl-1">
                                {" "}
                                {member.Name}
                              </span>
                            </td>
                            <td className="col-md-2 mt-2">
                              {formatNumber(member.HoursThisWeek)}
                            </td>
                            <td className="col-md-2 mt-2">
                              <PlanningToWork WorkingWeekend={member.WorkingWeekend || false} />
                            </td>
                            <td className="col-md-2 mt-2">
                              {formatNumber(member.HoursNextWeek)}
                            </td>
                            <td className="col-md-2 mt-2">
                              {member.Comments}
                            </td>
                            <WorklogButtonRow
                              {...{
                                member,
                                toggled,
                                showModal,
                                toggleAccordion,
                                accordionId,
                                setToggled,
                                setCollapsed,
                                getCollapsedStatus,
                              }}
                            />
                          </div>
                          <Accordion.Collapse
                            eventKey={memberId}
                            scrollable={true}
                            className={accordionId}
                            id={accordionId + "-" + memberId}
                          >
                            <Card.Body
                              scrollable={true}
                              className="scrollable-dashboard scrollable-real-estate"
                            >
                              <div className="real-estate-table-container">
                                <div className={`${true ? "table-wrapper" : ""}`}>
                                  <table className="real-estate-modal-table tableSticky">
                                    { worklogTrackers.map((worklog, index) => (
                                      <React.Fragment key={worklog.ProjectId}>
                                        { index === 0 &&
                                          renderTableWorklogColumns(worklog.TableWorklog[0].Columns)
                                        }
                                        { worklog.TableWorklog.map((tableWorklog) =>
                                          renderTableWorklogRows(
                                            tableWorklog.Rows,
                                            worklog.TableWorklog[0].Columns,
                                            discardedColumnIds
                                          ))
                                        }
                                      </React.Fragment>
                                    ))}
                                  </table>
                                </div>
                              </div>
                            </Card.Body>
                          </Accordion.Collapse>                            
                        </Card>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </Accordion>
          </table>
          { selectedMember &&
            <WorklogModal
              isAllRbc={isAllRbc}
              isStaffer={isStaffer}
              currentUserId={currentUserId}
              selectedMember={selectedMember}
              showState={show}
              onHideFunction={onHide}
              fetchData={fetchData}
            />
          }
        </div>
      </div>
    );
  }
  return null;
};

const ColumnPropType = PropTypes.shape({
  Id: PropTypes.number.isRequired,
  Name: PropTypes.string.isRequired,
  Type: PropTypes.string.isRequired,
  Order: PropTypes.number.isRequired,
  LookupValues: PropTypes.string,
  LockStatus: PropTypes.number.isRequired,
});

const DataPropType = PropTypes.shape({
  Id: PropTypes.number.isRequired,
  ColumnId: PropTypes.number.isRequired,
  ColumnType: PropTypes.string,
  ColumnName: PropTypes.string,
  Value: PropTypes.string.isRequired,
  LookupValues: PropTypes.string,
  ColumnLockStatus: PropTypes.number.isRequired,
});

const RowPropType = PropTypes.shape({
  Id: PropTypes.number.isRequired,
  Row: PropTypes.number.isRequired,
  Data: PropTypes.arrayOf(DataPropType).isRequired,
});

const TablePropType = PropTypes.shape({
  Columns: PropTypes.arrayOf(ColumnPropType).isRequired,
  Rows: PropTypes.arrayOf(RowPropType),
});

DashboardWorklogTracker.propTypes = {
  isAllRbc: PropTypes.bool.isRequired,
  isStaffer: PropTypes.bool.isRequired,
  currentUserId: PropTypes.number.isRequired,
  realEstateTrackerMembers: PropTypes.arrayOf(
    PropTypes.shape({
      CompanyId: PropTypes.number.isRequired,
      CompanyName: PropTypes.string.isRequired,
      UserId: PropTypes.number.isRequired,
      Name: PropTypes.string.isRequired,
      Type: PropTypes.string.isRequired,
      TypeColor: PropTypes.string.isRequired,
      ActiveDeals: PropTypes.number.isRequired,
      LastUpdated: PropTypes.string.isRequired,
      WorklogTracker: PropTypes.arrayOf(
        PropTypes.shape({
          ProjectId: PropTypes.number.isRequired,
          ProjectName: PropTypes.string.isRequired,
          OwnerUserId: PropTypes.number.isRequired,
          OwnerUserName: PropTypes.string,
          EditorUserId: PropTypes.number.isRequired,
          EditorUserName: PropTypes.string.isRequired,
          Editors: PropTypes.array,
          Type: PropTypes.string.isRequired,
          TypeColor: PropTypes.string.isRequired,
          LastUpdated: PropTypes.string.isRequired,
          AllowWorklogEdit: PropTypes.bool.isRequired,
          TableWorklog: PropTypes.arrayOf(TablePropType).isRequired,
        })
      ).isRequired,
    })
  ).isRequired,
  fetchData: PropTypes.func,
};

export default DashboardWorklogTracker;
